import { UMFormGroup, UMIcon, UMR, UMSelect } from '../../urbanmap/_components';
import { PLAN } from '../proposition-c/tokens';
import { NumberField } from '../proposition-c/ui';
import type { ConsumptionImpact } from './hooks';
import type { AoParams } from './types';
import { ImpactCard } from './ui';

export function StepHypotheses({
  value, onChange, stations, years, impact, impactVariant, ready,
}: {
  value: AoParams;
  onChange: (v: AoParams) => void;
  stations: string[];
  years: string[];
  impact: ConsumptionImpact | null;
  impactVariant: 'A' | 'B';
  ready: boolean;
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', gap: 12, padding: 12, background: UMR.messageInfoBg, border: `1px solid ${UMR.messageInfoBorder}`, fontSize: 14 }}>
        <UMIcon name="gavel" size={20} color={UMR.blueLink} />
        <div>
          Ces hypothèses sont <strong>imposées par le cahier des charges</strong> et conditionnent la création du projet.
          Elles restent modifiables ensuite.
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <UMFormGroup label="Station météo de référence">
          <UMSelect
            value={value.weatherStation}
            ariaLabel="Station météo de référence"
            onChange={(weatherStation) => onChange({ ...value, weatherStation })}
            options={[{ value: '', label: 'À sélectionner…' }, ...stations.map((s) => ({ value: s, label: s }))]}
          />
        </UMFormGroup>
        <UMFormGroup label="Année météo de référence">
          <UMSelect
            value={value.weatherYear}
            ariaLabel="Année météo de référence"
            onChange={(weatherYear) => onChange({ ...value, weatherYear })}
            options={[{ value: '', label: 'À sélectionner…' }, ...years.map((y) => ({ value: y, label: y }))]}
          />
        </UMFormGroup>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
        <NumberField
          label="Ratio résidentiel"
          unit="%"
          min={1}
          value={value.ratioResidential}
          onChange={(ratioResidential) => onChange({ ...value, ratioResidential })}
          hint="Appliqué à l’habitat collectif et individuel"
        />
        <NumberField
          label="Ratio tertiaire"
          unit="%"
          min={1}
          value={value.ratioTertiary}
          onChange={(ratioTertiary) => onChange({ ...value, ratioTertiary })}
          hint="Tertiaire, santé, enseignement, commerce"
        />
        <NumberField
          label="Intensité sans DPE"
          unit="kWh/m²/an"
          min={1}
          value={value.intensityNoDpe}
          onChange={(intensityNoDpe) => onChange({ ...value, intensityNoDpe })}
          hint="Bâtiments sans DPE connu"
        />
      </div>

      <ImpactCard impact={impact} variant={impactVariant} ready={ready} />

      <div style={{ fontSize: 12, color: PLAN.accentStrong }}>
        Les consommations mesurées (points de livraison SNCU) ne sont pas ré-estimées : seule la correction météo s’y applique.
      </div>
    </div>
  );
}
